var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
import { useSafeId } from '../../../core/hooks/useSafeId';
/**
 * @tdr
 */
export var England = svgIcon(function (props) {
    var id1 = useSafeId();
    var id2 = useSafeId();
    return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12" }),
        React.createElement("g", { clipPath: "url(#".concat(id1, ")") },
            React.createElement("g", { clipPath: "url(#".concat(id2, ")") },
                React.createElement("path", { fill: "#fff", d: "M-2 0h16v12H-2V0Z" }),
                React.createElement("path", { fill: "#CE1124", d: "M5.04 0h1.92v12H5.04V0Z" }),
                React.createElement("path", { fill: "#CE1124", d: "M-2 5.04h16v1.92H-2V5.04Z" }))),
        React.createElement("rect", { width: "11.7", height: "11.7", x: ".15", y: ".15", stroke: "#53565A", strokeWidth: ".3", rx: "5.85" }),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: id1 },
                React.createElement("rect", { width: "12", height: "12", fill: "#fff", rx: "6" })),
            React.createElement("clipPath", { id: id2 },
                React.createElement("path", { fill: "#fff", d: "M-2 0h16v12H-2z" })))));
});
//# sourceMappingURL=England.js.map